import { render, staticRenderFns } from "./SportsDetail.vue?vue&type=template&id=2357b4dc&"
import script from "./SportsDetail.vue?vue&type=script&lang=js&"
export * from "./SportsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports